/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_No_LeaguesInputs */



/**
* | output |
* | --- |
* | "No leagues available." |
*
* @param {Promo_No_LeaguesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_no_leagues = /** @type {((inputs?: Promo_No_LeaguesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_No_LeaguesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune ligue disponible.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ligas disponibles.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma liga disponível.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun campionato disponibile.")
	return /** @type {LocalizedString} */ ("No leagues available.")
});